import * as React from 'react';
import type { FileError } from 'react-dropzone';

import { Alert, type AlertProps } from 'src/components/Alert';

type FileUploaderAlertProps = Omit<AlertProps, 'children'> & {
  errors: FileError[];
};

export function FileUploaderAlert(
  props: FileUploaderAlertProps
): React.ReactElement | null {
  const { errors: errorsProp, ...rest } = props;
  // De-duplicate error messages
  const errors = errorsProp.filter((err, index, errors) => {
    return errors.map((err2) => err2.code).indexOf(err.code) === index;
  });

  return (
    <Alert severity="error" {...rest}>
      {errors?.map((err, index) => (
        <div key={`error-${index}`}>{err.message}</div>
      ))}
    </Alert>
  );
}

export default FileUploaderAlert;
